import React from "react";
import YouTube from "react-youtube";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function HalfVideoPreview({ preview }) {
  let videoId = '';
  let isEmbedded = false;
  if (preview.video_urls?.includes('embed')) {
    videoId = preview.video_urls?.split('/').pop();
    isEmbedded = true;
  }

  const videoPosition = () => {
    if (preview.position === 0 || preview.position === "Top") {
      return "items-start"
    } else if (preview.position === 1 || preview.position === "Middle") {
      return "items-center"
    } else if (preview.position === 2 || preview.position === "Bottom") {
      return "items-end"
    } else {
      return "items-start"
    }
  }
  return (
    <div>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className={`preview-half-video flex ${videoPosition()}`} style={{ backgroundImage: `url(${preview.img_urls})`, backgroundSize: "100% 100%", backgroundRepeat: "no-repeat" }}>
          {preview.video_urls && preview.video_urls && (isEmbedded ? (
            <YouTube
              videoId={videoId}
              opts={{
                height: "262px",
                width: "100%",
              }}
              onReady={(event) => {
                event.target.playVideo();
              }}
              className="w-full" />
          ) : (
            <iframe src={preview.video_urls} className="w-full" controls autoPlay referrerPolicy="no-referrer" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default HalfVideoPreview;
